module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_adwords_call_volume-e1ec4fe6e421dc054c305eb1b1c4e0f7.png";